import { render } from "./TourBooking.vue?vue&type=template&id=5f73dad1"
import script from "./TourBooking.vue?vue&type=script&lang=js"
export * from "./TourBooking.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__